import { render, staticRenderFns } from "./introducePage.vue?vue&type=template&id=628b27e1&scoped=true&"
import script from "./introducePage.vue?vue&type=script&lang=js&"
export * from "./introducePage.vue?vue&type=script&lang=js&"
import style0 from "./introducePage.vue?vue&type=style&index=0&id=628b27e1&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.8.3@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "628b27e1",
  null
  
)

export default component.exports